export default __webpack_public_path__ + "static/media/raspberrycontroller.554fbd66.png";